module.exports = __webpack_public_path__ + "media/images/gallery/constellations/coma_berenices/com_gal-216c510297750578db8a8f238f100bc1.gif";